export default {
  data() {
    return {
      detailsExpanded: false
    };
  },
  computed: {
    detailButtonText() {
      return this.detailsExpanded ? this.$t('ui.hide') : this.$t('ui.more_details');
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bindDetailCollapseEvents();
    });
  },
  beforeDestroy() {
    this.unbindDetailCollapseEvents();
  },
  methods: {
    getDetailPanelId() {
      return 'statement-child-' + this.uniqueID;
    },
    onDetailExpanded() {},
    bindDetailCollapseEvents() {
      const panel = document.getElementById(this.getDetailPanelId());
      if (!panel) return;
      this._onDetailShown = () => {
        this.detailsExpanded = true;
        this.onDetailExpanded();
      };
      this._onDetailHidden = () => {
        this.detailsExpanded = false;
      };
      panel.addEventListener('shown.bs.collapse', this._onDetailShown);
      panel.addEventListener('hidden.bs.collapse', this._onDetailHidden);
    },
    unbindDetailCollapseEvents() {
      const panel = document.getElementById(this.getDetailPanelId());
      if (!panel || !this._onDetailShown) return;
      panel.removeEventListener('shown.bs.collapse', this._onDetailShown);
      panel.removeEventListener('hidden.bs.collapse', this._onDetailHidden);
    }
  }
};
